<div [class.collapsed]="collapsed" id="chatWindow" class="flex flex-column">
  <div (click)="collapse()" class="flex flex-row w-full align-content-between justify-content-between" id="chatHeader">
    <span>AI Assistants <p-tag icon="fa-solid fa-sparkles" rounded severity="warning" value="BETA" (click)="onBetaClick($event)"></p-tag></span>
    <div class="visible" [class.hidden]="collapsed">
      <span (click)="onSettingsClick($event)" class="px-2"><i class="fa-regular fa-cog"></i></span>
      <span><i class="fa-regular fa-times"></i></span>
    </div>
  </div>
  <div id="chatContent" class="flex-grow-1">
    <app-assistant-picker-screen (selectAssistantEvent)="selectAssistant($event)"
                                 *ngIf="currentScreen === 'assistants' && assistantsLoaded"></app-assistant-picker-screen>
    <app-assistant-conversation (backToSelection)="selectAssistant(undefined)" *ngIf="currentScreen === 'conversation'"
                                [assistant]="currentSelectedAssistant"></app-assistant-conversation>
  </div>
</div>

<p-dialog [(visible)]="settingsVisible" modal="true" header="AI Settings" styleClass="w-full xl:w-6">
  <app-field-wrapper labelsWidth="110px" *ngIf="globalSettingsService.ready">
    <h2>Descriptions <i class="far fa-info-circle"
                        pTooltip="These descriptions will be used to aid the AI assistant's in providing answers relevant to your organization.
                        The more information you provide, the more accurate the AI assistant will be."></i></h2>
    <w-textarea-field rowSpan="3" label="Organization" [(value)]="orgDesc"></w-textarea-field>
    <w-textarea-field rowSpan="3" label="Employees" [(value)]="empDesc"></w-textarea-field>
    <w-textarea-field rowSpan="3" label="Contacts" [(value)]="custDesc"></w-textarea-field>
    <w-single-select label="AI Focus" [options]="aiFocusOptions" [(value)]="aiFocus"></w-single-select>
    <button (click)="saveSettings()" class="w-full"><i class="far fa-save"></i> Save</button>
  </app-field-wrapper>
  <p-spinner *ngIf="!globalSettingsService.ready"></p-spinner>
</p-dialog>
